import { Injectable } from '@angular/core';
import { ScriptLoaderService, ScriptModel } from './script-loader.service';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
public isQualtricsLoaded = false;
  constructor(private scriptLoader: ScriptLoaderService) { }
  loadScript(): Observable<ScriptModel> {
    this.scriptLoader.removeScript('qualtrics-subscript');
    this.scriptLoader.removeScript('qualtrics-wb');
    return this.scriptLoader.load({id: 'qualtrics-wb', src: `/assets/js/${environment.qualtrics.src}`, loaded: false});
  }
}
